import React, { Component, Fragment } from 'react';
import { withI18n } from '@lingui/react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import * as constants from '../constants';
import { getOptionLabelLocalized } from '../intl-helpers';

class ProductClassFilterActiveBlock extends Component {
    render() {
        const { label, children } = this.props;

        return (
            <div className="float-left">
                <span className="text-bold">{label}:</span> {children}
            </div>
        );
    }
}

class ProductClassFilterActiveLabel extends Component {
    render() {
        const { label, onClear } = this.props;

        return (
            <span className="label label-secondary" style={{ marginRight: '5px' }}>
                {label}{' '}
                {onClear && (
                    <i
                        onClick={onClear}
                        className="icon icon-cross c-hand"
                        style={{
                            position: 'relative',
                            top: '-2px',
                        }}
                    />
                )}
            </span>
        );
    }
}

class ProductClassFilterActive extends Component {
    renderActiveFilters() {
        const { i18n, language, showClearBtn } = this.props;
        // console.warn(this.props.attributes);

        let blocks = [];

        // console.log(this.props.activeFilters.toJS());

        this.props.activeFilters.forEach((values, key) => {
            const attribute = this.props.attributes.find((a) => a.key === key);

            if (attribute) {
                switch (attribute.type) {
                    case constants.ATTRIBUTE_TYPE_ALPHANUMERIC:
                    default:
                        blocks.push(
                            <ProductClassFilterActiveBlock
                                label={getOptionLabelLocalized(language)(attribute)}
                                key={key}
                            >
                                <Fragment>
                                    {values.map((v) => {
                                        //const option = attribute.filters.find(
                                        //    f => f.value === v
                                        //);

                                        const option = _.find(attribute.data, (f) => f.value === v);

                                        // console.log(v);
                                        // console.log(attribute.toJS());
                                        // console.log(option);

                                        if (!option) {
                                            return null;
                                        }

                                        return (
                                            <ProductClassFilterActiveLabel
                                                label={
                                                    attribute.type ===
                                                    constants.ATTRIBUTE_TYPE_RANGE
                                                        ? option.label
                                                        : getOptionLabelLocalized(language)(option)
                                                }
                                                key={option.value}
                                                onClear={
                                                    showClearBtn
                                                        ? () =>
                                                              this.props.onCheckboxToggle(
                                                                  attribute.key,
                                                                  option.value
                                                              )
                                                        : null
                                                }
                                            />
                                        );
                                    })}
                                </Fragment>
                            </ProductClassFilterActiveBlock>
                        );
                        break;
                    case constants.ATTRIBUTE_TYPE_LOGIC:
                        blocks.push(
                            <ProductClassFilterActiveBlock
                                label={getOptionLabelLocalized(language)(attribute)}
                                key={key}
                            >
                                <ProductClassFilterActiveLabel
                                    label={values === 'yes' ? i18n._('yes') : i18n._('no')}
                                    onClear={
                                        showClearBtn
                                            ? () => this.props.onChangeBooleanField(key, 'all')
                                            : null
                                    }
                                />
                            </ProductClassFilterActiveBlock>
                        );
                        break;
                    case constants.ATTRIBUTE_TYPE_NUMERIC:
                        const [start, end] = values;

                        blocks.push(
                            <ProductClassFilterActiveBlock
                                label={getOptionLabelLocalized(language)(attribute)}
                                key={key}
                            >
                                <ProductClassFilterActiveLabel
                                    label={i18n._('between:start:end', {
                                        start,
                                        end,
                                    })}
                                    onClear={
                                        showClearBtn
                                            ? () => this.props.onAttributeResetClick(key)
                                            : null
                                    }
                                />
                            </ProductClassFilterActiveBlock>
                        );
                }
            }
        });

        return <Fragment>{blocks}</Fragment>;
    }

    render() {
        return <div className="mb-2">{this.renderActiveFilters()}</div>;
    }
}

ProductClassFilterActive.propTypes = {
    activeFilters: PropTypes.object,
    attributes: PropTypes.object,
    language: PropTypes.string,
    showClearBtn: PropTypes.bool,
    // noTextActiveFilters: PropTypes.object,
    onCheckboxToggle: PropTypes.func.isRequired,
};

ProductClassFilterActive.defaultProps = {
    activeFilters: {},
    attributes: [],
    showClearBtn: true,
};

export default withI18n()(ProductClassFilterActive);
